import { createContext, useContext } from "react";
import { createPortal } from "react-dom";

export const TopBarSlotContext = createContext(null);

// Lets a page render its own controls (e.g. the conversation title) inside the shared top bar.
export function TopBarPortal({ children }) {
  const slot = useContext(TopBarSlotContext);
  return slot ? createPortal(children, slot) : null;
}
